/**
 * Минимальные CSV-импорт/экспорт без внешних зависимостей.
 * RFC 4180-совместимый — экранирование значений с запятыми/кавычками/переносами.
 */

export function parseCsv(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let field = ''
  let inQuotes = false
  let i = 0
  // Уберём BOM если есть
  if (text.charCodeAt(0) === 0xfeff) text = text.slice(1)

  while (i < text.length) {
    const ch = text[i]
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"'; i += 2
        } else {
          inQuotes = false; i++
        }
      } else {
        field += ch; i++
      }
    } else {
      if (ch === '"') { inQuotes = true; i++ }
      else if (ch === ',' || ch === ';' || ch === '\t') {
        row.push(field); field = ''; i++
      }
      else if (ch === '\n' || ch === '\r') {
        row.push(field); field = ''
        if (row.length > 1 || row[0] !== '') rows.push(row)
        row = []
        i++
        if (ch === '\r' && text[i] === '\n') i++
      }
      else { field += ch; i++ }
    }
  }
  if (field || row.length) { row.push(field); rows.push(row) }
  return rows
}

/**
 * Защита от CSV-injection: ячейка, начинающаяся с = + - @ Tab CR, при открытии
 * в Excel/Sheets интерпретируется как формула. Префиксуем апострофом, чтобы
 * табличный редактор показал её как обычный текст.
 */
function neutralizeFormula(s: string): string {
  return /^[=+\-@\t\r]/.test(s) ? `'${s}` : s
}

export function toCsv(rows: (string | number | null | undefined)[][], delimiter = ','): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          const s = neutralizeFormula(cell == null ? '' : String(cell))
          if (s.includes(delimiter) || s.includes('"') || s.includes('\n') || s.includes('\r')) {
            return `"${s.replace(/"/g, '""')}"`
          }
          return s
        })
        .join(delimiter),
    )
    .join('\r\n')
}

/** Скачать строку как файл. */
export function downloadFile(filename: string, content: string, mime = 'text/csv') {
  const blob = new Blob(['﻿' + content], { type: `${mime};charset=utf-8` })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
